/**
 * `v3.host.tokens.*` — the loop host's side of the Claude token pool, authenticated by its
 * run token ({@link V3HostMiddleware}), like `v3.host.checks.*`. Payloads live in
 * `@fm/v3/tokens`. Every call names the caller's own run.
 *
 * - `lease` — a token for one agent: its index into `CLAUDE_CODE_OAUTH_TOKENS`, its
 *   fingerprint and the raw Claude token (Redacted in memory, never logged), or
 *   `AllTokensExhausted` when every token is at its limit.
 * - `exhausted` — an agent hit a usage limit on the token named by its fingerprint; the
 *   pool parks it until the reset (or a cooldown) and says until when.
 *
 * A separate group from `V3HostRpcs` so its handlers live in their own router file.
 *
 * Handlers: `v3-host-tokens.router.ts`.
 *
 * @since 1.0.0
 */
import { Rpc, RpcGroup } from "@effect/rpc";
import {
  AllTokensExhausted,
  TokenExhaustedInput,
  TokenExhaustedResult,
  TokenLease,
  TokenLeaseInput,
} from "@fm/v3/tokens";
import { Schema } from "effect";
import { DatabaseError, ValidationError } from "../errors.ts";
import { V3HostMiddleware } from "./v3-host.tags.ts";

/**
 * @since 1.0.0
 */
export class V3HostTokenRpcs extends RpcGroup.make(
  Rpc.make("v3.host.tokens.lease", {
    payload: TokenLeaseInput,
    success: TokenLease,
    error: Schema.Union(ValidationError, AllTokensExhausted, DatabaseError),
  }).middleware(V3HostMiddleware),
  Rpc.make("v3.host.tokens.exhausted", {
    payload: TokenExhaustedInput,
    success: TokenExhaustedResult,
    error: Schema.Union(ValidationError, DatabaseError),
  }).middleware(V3HostMiddleware),
) {}
